import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/password-reset/', { email: email.trim() });
      setMessage(res.data?.detail || 'Если аккаунт есть, мы отправили письмо.');
      setDone(true);
    } catch (err) {
      const data = err.response?.data;
      setError(
        data?.email?.[0]
        || data?.detail
        || data?.error
        || 'Не удалось отправить запрос. Попробуйте позже.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Восстановление пароля</h2>
        <p className="auth-subtitle">
          Укажите email или логин — пришлём ссылку для сброса пароля
        </p>
        {done ? (
          <>
            <div className="alert alert-success">{message}</div>
            <p className="auth-link">
              <Link to="/login">Вернуться ко входу</Link>
            </p>
          </>
        ) : (
          <>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="reset-email">Email или логин</label>
                <input
                  id="reset-email"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email@example.com или логин"
                  required
                  autoFocus
                  autoComplete="username"
                />
              </div>
              <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                {loading ? 'Отправка...' : 'Отправить ссылку'}
              </button>
            </form>
            <p className="auth-link">
              Вспомнили пароль? <Link to="/login">Войти</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
